import React, { useState, useEffect } from "react";
import { Row, Col, Alert, Container, CardBody, Card } from "reactstrap";
import { Link } from "react-router-dom";
import { FaHome } from "react-icons/fa";
// availity-reactstrap-validation
import { AvForm } from "availity-reactstrap-validation";
import CMSLogo from "../../assets/images/long-logo.svg";

const EmailCheck = (props) => {
  const [EmailMessage, setEmailMessage] = useState("");

  useEffect(() => {
    // set email message after send request to email
    setEmailMessage(props?.location?.state?.messageEmail);
    return function cleanup() {};
  }, []);

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <FaHome size={32} />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center"></div>
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody className="p-5">
                  <Link to="/" className="mb-2 d-block auth-logo">
                    <img
                      style={{ marginLeft: "auto", marginRight: "auto" }}
                      src={CMSLogo}
                      alt=""
                      height="40"
                      className="logo logo-dark"
                    />
                  </Link>
                  <div className="text-center mt-3">
                    <h5
                      style={{
                        color: "#000000 !important",
                        fontSize: 15,
                      }}
                    >
                      RESET PASSWORD
                    </h5>
                    {EmailMessage && (
                      <div className="text-wrapper text-muted">
                      <div dangerouslySetInnerHTML={{ __html: EmailMessage }} />
                    </div>
                    )}
                    {/* <div>{EmailMessage}</div> */}
                  </div>
                  <div className="p-2">
                    <AvForm className="form-horizontal">
                      {props.error && typeof props.error === "string" ? (
                        <Alert color="danger">{props.error}</Alert>
                      ) : null}

                      <div className="mt-3 text-center text-decoration-underline">
                        <Link to="/" className="text-dark">
                          Back to login
                        </Link>
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EmailCheck;
